
export const headerData = {
    name: 'Yash Desai',
    title: "Hello! I am",
    desciption: "Hello! I am Yash Desai, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. ",
    image: '',
    resumePdf: 'banavanu'
}
